export const METHOD_GET = 'get';
export const METHOD_DELETE = 'delete';
export const METHOD_PUT = 'put';
export const METHOD_POST = 'post';


// WEBPACK FOOTER //
// ./src/utils/http-methods.js